/* esm.sh - micromark-extension-gfm-table@2.1.1 */
export * from "/*micromark-extension-gfm-table@2.1.1/esnext/micromark-extension-gfm-table.mjs";
